export enum LogLevel {
  DEBUG = 0,
  INFO = 1,
  WARN = 2,
  ERROR = 3,
}

export function shouldLog(entryLevel: LogLevel, minLevel: LogLevel): boolean {
  return entryLevel >= minLevel;
}

export function levelLabel(level: LogLevel): string {
  return LogLevel[level];
}
